export default {
  imageFileTooBig: 'File size too large. Images must be less than 10MBs.',
  imageResolutionTooBig: 'Resolution must be smaller than 10000 x 10000 pixels.',
};
